import type { Decimal } from '../math/num';
import { D } from '../math/num';
import type { Rarity } from './parts/partTypes';

/**
 * The Foundry — Sir Loin's unlock (MINIGAME_PROPOSALS O5). Slot three
 * duplicates of the same part def + rarity into the forge with Components;
 * after an idle timer, out comes ONE copy at the next rarity. Active play:
 * a heat-timing strike on collection grants a bonus affix (skippable, the
 * idle-safe default just collects).
 *
 * Interlock: parts + Components -> better parts -> MechMaxxing. The payoff is
 * multiplicative only through the EXISTING rarity multiplier (x1.15..x2.65);
 * no new global stat. The forge is the ONLY source of the top two tiers:
 * Based x3 -> Unit, Unit x3 -> GOATED (drops stop at Based). Numbers here
 * are first-pass; Jesse tunes by feel.
 */

export const FUSE_COUNT = 3;

/** The rarity a fusion produces from a given input rarity (null = can't fuse). */
export const FUSE_TARGET: Partial<Record<Rarity, Rarity>> = {
  common: 'uncommon',
  uncommon: 'rare',
  rare: 'epic',
  epic: 'legendary',
  legendary: 'unit',
  unit: 'goated',
};

/** Idle timer per TARGET rarity. Long enough to feel forged, short enough to
 *  check between waves; the forged-exclusive tiers are overnight projects. */
export const FUSE_DURATION_MS: Record<Rarity, number> = {
  common: 0, // never a target
  uncommon: 2 * 60_000,
  rare: 8 * 60_000,
  epic: 25 * 60_000,
  legendary: 60 * 60_000,
  unit: 150 * 60_000,
  goated: 6 * 60 * 60_000,
};

/** Components cost per TARGET rarity. Deliberately flat: late-game fusing of
 *  low parts is cheap QoL, fusing toward the forged tiers is a real spend. */
export function fuseCost(target: Rarity): Decimal {
  const base: Record<Rarity, number> = { common: 0, uncommon: 20, rare: 90, epic: 400, legendary: 1800, unit: 8000, goated: 35000 };
  return D(base[target]);
}
